import { useController, UseControllerProps } from "react-hook-form";
import React, { FC } from "react";
import { CheckboxProps, FormControl, FormHelperText } from "@mui/material";
import { modificateRequiredRule } from "helpers/validation/utils";
import Checkbox from "./components/Checkbox";

export type TCheckboxProp = {
  name: string;
  label?: string | React.ReactNode;
  handleChange?: (value: boolean) => void;
  rules?: UseControllerProps["rules"];
  hint?: string;
};

const CheckboxControl: FC<CheckboxProps & TCheckboxProp> = ({
  sx,
  name,
  label,
  disabled,
  handleChange,
  rules,
  hint,
}) => {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ name, defaultValue: false, rules: modificateRequiredRule(rules) });
  return (
    <FormControl error={!!error}>
      <Checkbox
        sx={sx}
        label={label}
        handleChange={(checked) => {
          onChange(checked);
          handleChange?.(checked);
        }}
        value={value}
        disabled={disabled}
      />
      {(error?.message || hint) && <FormHelperText>{error?.message || hint}</FormHelperText>}
    </FormControl>
  );
};

export default CheckboxControl;
